/**
 * @generated SignedSource<<10a524d8a265b2ef146dd954ec86f385>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NativeIssueTableWithSelectedIssuesProvider_columns$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly aliases?: ReadonlyArray<string> | null | undefined;
      readonly displayName: string;
      readonly fieldSetId: string;
      readonly fieldSetPreferences: {
        readonly width: number | null | undefined;
      } | null | undefined;
      readonly fieldsMetadata?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly canBeConfigured: boolean | null | undefined;
            readonly fieldId: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly isPlaceHolderField: boolean | null | undefined;
      readonly isSortable: boolean | null | undefined;
      readonly jqlTerm: string;
      readonly type: string;
    };
  } | null | undefined>;
  readonly totalCount: number;
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer" | "IssueFetchQueryVariables" | "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef">;
  readonly " $fragmentType": "NativeIssueTableWithSelectedIssuesProvider_columns";
};
export type NativeIssueTableWithSelectedIssuesProvider_columns$key = {
  readonly " $data"?: NativeIssueTableWithSelectedIssuesProvider_columns$data;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider_columns">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "NativeIssueTableWithSelectedIssuesProvider_columns",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IssueFetchQueryVariables"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "totalCount"
      },
      "action": "THROW",
      "path": "totalCount"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssueSearchFieldSetEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraIssueSearchFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "fieldSetId"
                  },
                  "action": "THROW",
                  "path": "edges.node.fieldSetId"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  "action": "THROW",
                  "path": "edges.node.type"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  "action": "THROW",
                  "path": "edges.node.displayName"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "jqlTerm"
                  },
                  "action": "THROW",
                  "path": "edges.node.jqlTerm"
                },
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "aliases"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "isSortable"
                },
                {
                  "concreteType": "JiraFieldSetPreferences",
                  "kind": "LinkedField",
                  "name": "fieldSetPreferences",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "width"
                    }
                  ]
                },
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "concreteType": "JiraIssueSearchFieldMetadataConnection",
                      "kind": "LinkedField",
                      "name": "fieldsMetadata",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueSearchFieldMetadataEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "JiraIssueSearchMetadataField",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "canBeConfigured"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "fieldId"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "isPlaceHolderField"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "edges.node"
          }
        ]
      },
      "action": "THROW",
      "path": "edges"
    },
    {
      "kind": "FragmentSpread",
      "name": "ColumnConfigWithContainer"
    },
    {
      "kind": "FragmentSpread",
      "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef"
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};

(node as any).hash = "1b4c38bed9d29dd542d8e29a16f86aeb";

export default node;
